import 'consumerweb-shim';
import 'adsinterceptor';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { get, uniq } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import { Text } from 'pp-react';
import MediaQuery from 'react-responsive';
import * as analytics from '../lib/analytics';

import SimpleHeader from '../components/SimpleHeader';
import CharityLogo from '../components/charityLogo';
import DonateBox from '../components/donateBox';
import Benefits from '../components/benefits/benefits';
import SocialShare from '../components/SocialShare';
import CheckoutError from '../components/checkoutError';
import CobrandedHeader from '../components/cobranded-header';

import content from '../lib/i18n';
import styles from './fundraiser-charity.less';
import { getType, isPPGF } from '../lib/charity';
import DonationTerms from '../components/donation-terms';
import glamorous from 'glamorous';
import { Footer } from 'marketing-components';
const i18n = content('campaignCharity');

const HeroStyle = {
  backgroundImage: 'linear-gradient(279deg, #1546a0, #0070ba)',
};

/*
  This page is the charity profile page for charities that are 
  part of a campaign. The difference between this page, and the 
  hub-npo.js page is that a user who sets up a campaign/fundraiser
  can customize features, content, and the view, of the campaign 
  which are propogated to this charity page. 

  TODO: Consolidate this and the hub-npo.js page to let us use
  only one component for this page.
*/

const DonationTermsStyle = glamorous.div({
  padding: '10px 30px 10px 30px',
  borderTop: '1px solid #e2e8ec',
});

class Page extends React.Component {
  static propTypes = {
    csrf: PropTypes.string,
    description: PropTypes.string,
    website_url: PropTypes.string,
    mission_area: PropTypes.array,
    resources: PropTypes.object,
    states: PropTypes.object,
    address: PropTypes.object,
  };

  static childContextTypes = {
    csrf: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);
    const nameValues = this.parseFPTIInfo(props && props.fptiInfo);

    const initialState = {
      fptiInfo: {
        pgrp: nameValues.pgrp,
        page: nameValues.page,
      },
    };
    this.state = initialState;
  }

  parseFPTIInfo = fptiData => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  getChildContext() {
    return {
      csrf: this.props.csrf,
    };
  }

  handleAnalyticsCategory = category => {
    analytics.trackLinkWithData(
      'CategoryClicked',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      { category: category },
      'link'
    );
  };

  handleAnalyticsWebLink = () => {
    analytics.trackLink(
      'WebsiteLink',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      'link'
    );
  };

  renderHeader = () => {
    const cobranded = get(
      this.props.campaign,
      'templateData.campaignBranding.campaignBrand',
      ''
    );
    const logo = get(this.props.campaign, 'templateData.lpContents.logoImage');
    if (cobranded.toUpperCase() === 'COBRANDED' && logo) {
      return <CobrandedHeader cobrandedLogo={logo} />;
    } else {
      return (
        <SimpleHeader
          hasBorder={false}
          hasHomeLink={true}
          homeLink={this.props.resources.homeLink}
        />
      );
    }
  };

  renderAbout = () => {
    const npid = this.props.nonprofit_id;
    const charityContent = this.props.charityContent;

    let categories = [];
    if (Array.isArray(this.props.cause_area)) {
      categories =
        uniq(
          this.props.cause_area.map(causeArea =>
            i18n(`label.category-${causeArea.id}`)
          )
        ) || [];
    }

    let link;
    if (this.props.website_url) {
      link = (
        <a
          onClick={this.handleAnalyticsWebLink}
          target={'_blank'}
          href={this.props.website_url}
        >
          <Text size='sm' regular>
            {i18n('label.view-website')}
          </Text>
        </a>
      );
    }

    let ein;
    if (this.props.ein) {
      ein = (
        <Text as='p' size='md'>
          {`${i18n(charityContent.einLabel)}`}&nbsp;
          <span>{this.props.ein}</span>
        </Text>
      );
    }

    let source;
    const charityType = get(this.props.charity, 'charity_type');
    if (charityContent.source && isPPGF(charityType)) {
      source = (
        <Text as='p' size='md'>
          {`${i18n(charityContent.sourceLabel)}`}&nbsp;
          <span style={{ fontWeight: 'bold' }}>
            {i18n(charityContent.source)}
          </span>
        </Text>
      );
    }

    const address = this.props.address;
    const cityState = (
        <Text as='p' size='md'>
         {[address.city, address.state].filter(x => !!x).join(', ')}
        </Text>
      );


    const about = (
      <div className={'panel'}>
        <div>
          <Text as='h1' size='xl2' className={styles['npo-charityTitle']}>
            {i18n('label.about-this-charity')}
          </Text>
          <Text as='p' size='md'>
            {this.props.description}
          </Text>
          <div style={{ paddingTop: '30px' }}>
            {categories.map((category, categoryIndex) => {
              if (categoryIndex === categories.length - 1) {
                return (
                  <a
                    onClick={this.handleAnalyticsCategory.bind(this, category)}
                    key={`np-${npid}-${categoryIndex}`}
                    href={`${this.props.resources.searchLink}?category=${category}`}
                  >
                    <Text size='md' regular className={styles.categoryDisplay}>
                      {category}
                    </Text>
                  </a>
                );
              } else {
                return (
                  <span>
                    <a
                      onClick={this.handleAnalyticsCategory.bind(
                        this,
                        category
                      )}
                      key={`np-${npid}-${categoryIndex}`}
                      href={`${this.props.resources.searchLink}?category=${category}`}
                    >
                      <Text
                        size='md'
                        regular
                        className={styles.categoryDisplay}
                      >
                        {category}
                      </Text>
                    </a>
                    ,{' '}
                  </span>
                );
              }
            })}
          </div>
          <div>
            {ein}
            {cityState}
            {link}
            {source}
          </div>
        </div>
      </div>
    );
    return about;
  };

  renderBenefits = () => {
    const charityType = get(this.props.charity, 'charity_type');
    if (isPPGF(charityType)) {
      let percentage;
      if (this.props.campaign.countryCode === 'GB') {
        percentage = '100%';
      } else {
        percentage = '101%';
      }

      return (
        <div className={'panel'}>
          <Benefits layout={'vertical'} percentToCharity={percentage} />
        </div>
      );
    }
  };

  renderSocialShare = () => {
    let social;
    const socialShareNeeded = get(
      this.props,
      'campaign.templateData.socialShareNeeded',
      'yes'
    );
    if (socialShareNeeded === 'yes') {
      social = (
        <div className={'panel'}>
          <SocialShare
            url={window.location.href}
            campaignInfo={this.props.campaign}
            fptiInfo={this.state.fptiInfo}
          />
          <div className={'vx_small-text'} style={{ textAlign: 'center' }}>
            <Text as='p' size='md' regular>
              {i18n('label.spred-the-word')}
            </Text>
            <Text size='md'>{i18n('label.share-message')}</Text>
          </div>
        </div>
      );
      return social;
    }
  };

  renderDonationTerms = () => {
    const type = getType(this.props.charity);
    const charityContent = this.props.charityContent;

    return (
      <DonationTermsStyle>
        <DonationTerms type={type} charityContent={charityContent} />
      </DonationTermsStyle>
    );
  };

  renderDonate = () => {
    const state = get(this.props, 'campaign.state', 'ACTIVE');
    const active = state === 'ACTIVE';
    const formUrl =
      this.props.coBrand + 'charity/' + this.props.nonprofit_id + '/xo/create';

    const donate = (
      <div className={'panel'}>
        <DonateBox
          {...this.props}
          formUrl={formUrl}
          charity={this.props.charity}
          active={active}
          fptiInfo={this.state.fptiInfo}
          label_alltocharity={i18n('label.all-to-charity')}
        />
        {this.renderDonationTerms()}
      </div>
    );
    return donate;
  };

  renderGiftsDoMore = () => {
    const charityType = get(this.props.charity, 'charity_type');
    const charityContent = this.props.charityContent;

    if (isPPGF(charityType)) {
      return (
        <div>
          <div className={'npo-gifts-do-more'}>
            <Text
              className={'recieptInfo'}
              dangerouslySetInnerHTML={{
                __html: i18n(charityContent.legalDisclaimer),
              }}
              as='p'
              size='sm'
            />
          </div>
        </div>
      );
    }
  };

  renderFooter = () => {
    const {
      content: { content: footerContent },
    } = JSON.parse(document.getElementById('data-footer').innerHTML);
    const { localeCountry } = footerContent;

    if (footerContent) {
      return (
        <Footer
          content={footerContent}
          localeCountry={localeCountry}
          flagHref={`https://www.paypal.com/${localeCountry.toLowerCase()}/webapps/mpp/country-worldwide`}
        />
      );
    }
  };

  renderError = () => {
    if (this.props.donationInfo && this.props.donationInfo.donated === 0) {
      return <CheckoutError fptiInfo={this.state.fptiInfo} />;
    }
  };

  render() {
    const about = this.renderAbout();
    const benefits = this.renderBenefits();
    const social = this.renderSocialShare();
    const donate = this.renderDonate();
    const giftsDoMore = this.renderGiftsDoMore();

    return (
      <div>
        {this.renderHeader()}
        <div className={'cause-viewport'}>
          <div>
            <div className={'cause-charity-hero'} style={HeroStyle} />
            <CharityLogo {...this.props} />
            <div style={{ maxWidth: '1024px', margin: 'auto' }}>
              <MediaQuery minWidth={901}>
                <Row>
                  <Col xs={7} md={7} lg={7}>
                    {about}
                    {benefits}
                  </Col>
                  <Col xs={5} md={5} lg={5}>
                    {donate}
                    {social}
                  </Col>
                </Row>
              </MediaQuery>
              <MediaQuery minWidth={601} maxWidth={900}>
                <Row>
                  <Col xs={6} md={6} lg={6}>
                    {about}
                    {benefits}
                  </Col>
                  <Col xs={6} md={6} lg={6}>
                    {donate}
                    {social}
                  </Col>
                </Row>
              </MediaQuery>
              <MediaQuery maxWidth={600}>
                {donate}
                {about}
                {benefits}
                {social}
              </MediaQuery>
            </div>
            <div>{giftsDoMore}</div>
            {this.renderError()}
            {this.renderFooter()}
          </div>
        </div>
      </div>
    );
  }
}

const campaign = JSON.parse(
  document.getElementById('campaign-props').innerHTML
);
const charity = JSON.parse(document.getElementById('charity-props').innerHTML);
const donationInfo = JSON.parse(
  document.getElementById('donation-info-props').innerHTML || '{}'
);
const states = JSON.parse(document.getElementById('states-props').innerHTML);
const amounts = JSON.parse(document.getElementById('amounts-props').innerHTML);
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);
const csrf = document.getElementById('data-csrf').innerHTML;
const coBrand = document.getElementById('data-co-brand').innerHTML;
const hubUrl = `${coBrand}hub`;
const resources = JSON.parse(
  document.getElementById('data-resources').innerHTML
);

ReactDOM.render(
  <Page
    {...charity}
    charity={charity}
    campaign={campaign}
    donationInfo={donationInfo}
    states={states}
    csrf={csrf}
    fptiInfo={fptiInfo}
    coBrand={coBrand}
    amounts={amounts}
    hubUrl={hubUrl}
    resources={resources}
  />,
  document.getElementById('page')
);
